import { CardMedia } from "@material-ui/core";
import { Grid, Skeleton } from "@mui/material";
import styled from "styled-components";
import PreviewPhoto from "../../../../assets/img/previewph.png";

const CardSkeleton = () => {
  return (
    <Grid container columnSpacing={2} alignItems="center">
      <Grid item>
        <PreviewImageCards image={PreviewPhoto} />
      </Grid>
      <Grid item>
        <Skeleton variant="text" width={80} height={30} />
        <Skeleton variant="text" width={150} height={30} />
        <Grid container alignItems="center" columnSpacing={1}>
          <Grid item>
            <Skeleton variant="text" width={80} />
          </Grid>
          <Grid item>
            <Skeleton variant="circular" width={10} height={10} />
          </Grid>
          <Grid item>
            <Skeleton variant="text" width={80} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const PreviewImageCards = styled(CardMedia)({
  height: "120px",
  width: "120px",
});
export default CardSkeleton;
